var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar',{staticClass:"header",attrs:{"fixed":"","dark":"","color":_vm.$store.getters['site/siteColor']}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.title))]),_c('v-spacer'),_c('v-toolbar-items',[_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":_vm.closeDialog}},[_c('v-icon',[_vm._v("close")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }